import { PromoTagDocument } from "@/lib/prismicio/types.generated"
import { PrefetchResult, usePrefetch } from "@jog/react-components"
import { fetchS3PromoTag, transPromotionTag } from "@jog/shared"
import { useMemo } from "react"

export function prefetchPromoTag(prefetch: PrefetchResult["prefetch"]) {
    return prefetch("promoTag", () => fetchS3PromoTag<PromoTagDocument>().then((res) => transPromotionTag(res.data)))
}

export const usePromotionTag = (promotion?: string | Record<string, string>) => {
    const { data } = usePrefetch("promoTag")
    return useMemo(() => {
        if (!promotion) return
        if (typeof promotion === "string") {
            return data?.[promotion?.trim().toLowerCase()]
        }
        return data?.[promotion[process.env.NEXT_PUBLIC_LOCALE!].toLowerCase()]
    }, [data, promotion])
}
